import type { StatusColorTone } from '@/styles/statusColors';
import type {
  PcmpDisburseVerifyCounts,
  PcmpDisburseVerifyTab,
} from '../types/pcmpDisburseVerify.types';
import type {
  PcmpDisbursementConfirmStatus,
  PcmpDisbursementVerifyStatus,
} from '../types/pcmpProposal.types';

export const PCMP_DISBURSE_VERIFY_DEFAULT_TAB: PcmpDisburseVerifyTab = 'ACCOUNTS_PENDING';

export const PCMP_DISBURSE_VERIFY_TAB_LABELS = {
  ACCOUNTS_PENDING: 'Accounts Pending',
  MARKETING_PENDING: 'Marketing Pending',
  ACCOUNTS_VERIFIED: 'Accounts Verified',
  MARKETING_VERIFIED: 'Marketing Verified',
} as const satisfies Record<PcmpDisburseVerifyTab, string>;

export const PCMP_DISBURSE_VERIFY_TAB_COUNT = {
  ACCOUNTS_PENDING: (counts) => counts.accountsPending,
  MARKETING_PENDING: (counts) => counts.marketingPending,
  ACCOUNTS_VERIFIED: (counts) => counts.accountsVerified,
  MARKETING_VERIFIED: (counts) => counts.marketingVerified,
} as const satisfies Record<PcmpDisburseVerifyTab, (counts: PcmpDisburseVerifyCounts) => number>;

export const PCMP_DISBURSE_VERIFY_EMPTY_MESSAGE = {
  ACCOUNTS_PENDING: 'No Accounts payouts are waiting for verification',
  MARKETING_PENDING: 'No Marketing payouts are waiting for verification',
  ACCOUNTS_VERIFIED: 'No verified Accounts payouts found',
  MARKETING_VERIFIED: 'No verified Marketing payouts found',
} as const satisfies Record<PcmpDisburseVerifyTab, string>;

export const isPcmpDisburseVerifyPendingTab = (tab: PcmpDisburseVerifyTab): boolean =>
  tab === 'ACCOUNTS_PENDING' || tab === 'MARKETING_PENDING';

/** Longest confirm or verify remark (API PCMP_ACK_REMARKS_MAX_LENGTH, legacy 500). */
export const PCMP_ACK_REMARKS_MAX = 500;

export const PCMP_DISBURSEMENT_CONFIRM_LABELS = {
  PENDING: 'Pending Confirmation',
  CONFIRMED: 'Confirmed',
} as const satisfies Record<PcmpDisbursementConfirmStatus, string>;

export const PCMP_DISBURSEMENT_VERIFY_LABELS = {
  PENDING: 'Pending Verification',
  VERIFIED: 'Verified',
} as const satisfies Record<PcmpDisbursementVerifyStatus, string>;

export const PCMP_DISBURSEMENT_ACK_TONE = {
  PENDING: 'warning',
  CONFIRMED: 'success',
  VERIFIED: 'success',
} as const satisfies Record<
  PcmpDisbursementConfirmStatus | PcmpDisbursementVerifyStatus,
  StatusColorTone
>;
